<template>
  <el-container class="ActualSecurityFacilities">
    <!-- 实有安防设施 -->
    <el-card class="tree-card" :body-style="treeCard">
      <el-input
        v-model="filterText"
        placeholder="请输入关键词"
        class="input-with-select"
      >
        <template #prefix>
          <i class="iconfont icon-31sousuo"></i>
        </template>
      </el-input>
      <div class="tree-box">
        <el-tree
          ref="treeRef"
          :data="dataSource"
          node-key="id"
          highlight-current
          :props="{ label: 'name' }"
          :default-expanded-keys="[rootNodeKey]"
          @current-change="currentChange"
          :expand-on-click-node="true"
          :filter-node-method="filterNode"
        ></el-tree>
      </div>
    </el-card>
    <el-card class="tabs-card">
      <el-form
        :inline="true"
        ref="formRef"
        :model="tableParams"
        class="demo-form-inline"
      >
        <el-form-item label="设施类别" prop="securityType">
          <h-selectcode
            type="facilityType"
            v-model="tableParams.securityType"
            placeholder="设施类别"
            :clearable="true"
          ></h-selectcode>
        </el-form-item>
        <el-form-item>
          <h-button type="primary" @click="refreshTable">查询</h-button>
          <h-button @click="resetForm(formRef)">重置</h-button>
        </el-form-item>
        <el-row>
          <el-col>
            <h-button type="primary" @click="addButton">添加</h-button>
            <h-button type="danger" @click="delUser">删除</h-button>
            <el-dropdown>
              <h-button type="primary" :style="{ marginLeft: '10px' }"
                >导入导出
                <el-icon class="el-icon--right">
                  <arrow-down />
                </el-icon>
              </h-button>
              <template #dropdown>
                <el-dropdown-menu>
                  <el-dropdown-item @click="uploade">导入</el-dropdown-item>
                  <el-dropdown-item @click="exporting">导出</el-dropdown-item>
                  <el-dropdown-item @click="exportingAll"
                    >导出全部</el-dropdown-item
                  >
                  <el-dropdown-item @click="download"
                    >下载模板</el-dropdown-item
                  >
                  <input type="file" v-show="false" ref="file" @change="myup" />
                </el-dropdown-menu>
              </template>
            </el-dropdown>
          </el-col>
        </el-row>
        <el-row>
          <el-col class="security-count">
            <el-button style="background-color: #294a7c; color: #fff">
              全部设备：<span style="color: red">{{ facilityTypeCount }}</span>
            </el-button>
            <el-button v-for="item in facilityTypeDict" :key="item.code">
              {{ item.securityTypeDict }} : &nbsp;&nbsp;<span
                style="color: red"
                >{{ item.count }}</span
              >
            </el-button>
          </el-col>
        </el-row>
      </el-form>
      <div class="table-box">
        <h-table
          ref="tableRef"
          v-model:data="tableData"
          v-model:columns="columns"
          :method="securitylist"
          :params="tableParams"
          @handleClick="handleClick"
          @select="hzTableSelect"
        >
          <!-- <template #role="{row}">
            <div class="table-role" v-for="item in row.roleList" :key="item.roleId">{{item.roleName}}</div>
          </template>-->
          <template #imageUrl="{ row }">
            <!-- && row.imageUrl.indexOf('http') == -1 -->
            <span v-if="!row.imageUrl">{{ "暂无" }}</span>
            <img v-else :src="imgURL + row.imageUrl || imgMoren" />
          </template>
          <template #securityName="{ row }">
            <div class="table-role" @click="clickTable(row)">
              <span>{{ row.securityName }}</span>
            </div>
          </template>
          <template #regionId="{ row }">
            <div>
              <span>{{ optionsq(row.regionId) }}</span>
            </div>
          </template>
        </h-table>
      </div>
    </el-card>
    <actual-security-add
      v-model="formVisible"
      :form="userFormData"
      :status="formStatus"
      @submit="userSubmit"
    ></actual-security-add>
  </el-container>
</template>
<script>
import { defineComponent, nextTick, reactive, toRefs, ref } from "vue";
import { ElMessageBox, ElMessage } from "element-plus";
import actualSecurityAdd from "./components/actualSecurityAdd";
import {
  securitylist,
  securitydelete,
  securitycount,
} from "@/api/threeSolid/threeSolid.js";
import { ArrowDown } from "@element-plus/icons-vue";
import {
  getMenutree,
  uploadsecurity,
  derivesecurity,
  downloadsecurity,
} from "@/api/system/region.js";
import { regionselect } from "@/api/realHouse/realHouse.js";
import _ from "lodash";
import { getDict } from "@/api/constant";
import StreetTableVue from "../system/RegionManage/components/StreetTable.vue";

export default defineComponent({
  name: "ActualSecurityFacilities",
  components: { actualSecurityAdd, ArrowDown },
  props: {},
  setup(props) {
    const state = reactive({
      imgURL: window.imgURL,
      imgMoren: require("@/assets/images/moren.png"),
      filterText: "",
      rootNodeKey: "",
      treeCard: {
        height: "100%",
        display: "flex",
        flexDirection: "column",
      },
      dataSource: [],
      options: [],
      userFormData: {},
      tableParams: {
        cph: "",
        clpp: "",
        cllx: "",
        csys: "",
        syxz: "",
        sswy: "",
        jdcsyr: "",
      },
      tableData: [],
      tableSelection: [],
      formStatus: 1, // 1 添加  2 编辑
      formVisible: false,
      columns: [
        { type: "selection" },
        {
          label: "设施照片",
          slot: "imageUrl",
        },
        {
          label: "名称",
          slot: "securityName",
        },
        {
          label: "类别",
          prop: "securityTypeDict",
        },
        {
          label: "安装地址",
          prop: "securityAddress",
        },
        {
          label: "所属小区",
          slot: "regionId",
        },
        {
          type: "operate",
          label: "操作",
          width: "140px",
          operates: [
            { name: "编辑", emitKey: "edit" },
            { name: "删除", emitKey: "del", type: "danger" },
          ],
        },
      ],
      facilityTypeDict: [],
      facilityTypeCount: 0,
    });
    const file = ref();
    const refData = toRefs(state);
    // const treeRef = ref(null);
    const tableRef = ref(null);
    const formRef = ref(null);
    // 获取数据字典
    const querySecuritycount = async (val) => {
      let params = {};
      if (val) {
        params = {
          regionId: val,
        };
      }
      const res = await securitycount(params);
      state.facilityTypeDict = res.list;
      state.facilityTypeCount = res.list.reduce((pre, item) => {
        return pre + parseInt(item.count);
      }, 0);

      console.log(state.facilityTypeDict);
    };
    querySecuritycount();
    // 对组织树节点进行筛选时执行的方法
    const filterNode = (value, data, node) => {
      if (!value) return true;
      return data.label.indexOf(value) !== -1;
    };
    // 当前选中节点变化时触发的事件
    const currentChange = (item, nodes) => {
      state.tableParams.regionId = item.id;
      nextTick(() => {
        tableRef.value && tableRef.value.refresh();
        querySecuritycount(item.id);
      });
    };
    // 获取结构树
    const queryOrganTreAsync = async () => {
      const result = await getMenutree();
      const treeData = [result.data];
      state.dataSource = treeData;
      if (treeData[0]) {
        currentChange(treeData[0]);
        nextTick(() => {
          state.rootNodeKey = state.currentNode.id;
          // treeRef.value.setCurrentKey(state.currentNode.deptId);
        });
        state.rootNodeKey = treeData[0].children[0].id;
      }
    };
    queryOrganTreAsync();
    // 点击查询按钮
    const refreshTable = () => {
      tableRef.value && tableRef.value.refresh();
    };
    // 重置表单
    const resetForm = (formEl) => {
      if (!formEl) return;
      formEl.resetFields();
    };
    // 表单提交
    const userSubmit = () => {
      tableRef.value && tableRef.value.refresh();
    };
    // 点击table操作按钮
    const handleClick = (operate, row) => {
      const { emitKey } = operate;
      if (emitKey === "edit") {
        // 编辑
        state.formStatus = 2; // 把表单设置为编辑状态
        state.userFormData = _.cloneDeep(row);
        // state.userFormData.roleIdList = row.roleList.map(item => item.roleId);
        state.formVisible = true;
        nextTick(() => {});
      } else if (emitKey === "info") {
        // 详情
        state.formStatus = 3; // 把表单设置为查看状态
        state.userFormData = _.cloneDeep(row);
        state.formVisible = true;
      } else if (emitKey === "del") {
        ElMessageBox.confirm("您确认要删除该实有安防设施吗？", "删除", {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning",
        }).then(
          () => {
            deleteUserAsync([row.securityFacilitiesId]);
          },
          () => {}
        );
      }
    };
    // 当用户手动勾选数据行的 Checkbox 时触发的事件
    const hzTableSelect = (selection) => {
      state.tableSelection = selection;
    };
    // 点击添加按钮
    const addButton = () => {
      state.formStatus = 1;
      state.formVisible = true;
    };
    const deleteUserAsync = async (ids) => {
      const res = await securitydelete(ids);
      if (res.code === 0) {
        refreshTable();
        state.tableSelection = [];
        ElMessage({
          type: "success",
          message: "删除成功",
        });
      }
    };
    // 批量删除用户
    const delUser = () => {
      if (state.tableSelection.length > 0) {
        ElMessageBox.confirm("您确认要删除选择的实有安防设施吗？", "删除", {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning",
        }).then(
          () => {
            const ids = state.tableSelection.map(
              (item) => item.securityFacilitiesId
            );
            deleteUserAsync(ids);
          },
          () => {}
        );
      } else {
        ElMessage({
          type: "warning",
          message: "请选择要删除的实有安防设施",
        });
      }
    };
    const clickTable = async (item) => {
      console.log(item);
      state.userFormData = _.cloneDeep(item);
      state.formStatus = 3;
      state.formVisible = true;
    };
    const regionselectxQ = async () => {
      const params = {
        type: 3,
      };
      const res = await regionselect(params);
      state.options = res.data;
    };
    regionselectxQ();
    const optionsq = (is) => {
      let str = "";
      state.options.forEach((item) => {
        if (item.regionId === is) {
          str = item.name;
        }
      });
      return str;
    };
    // 导入
    const uploade = () => {
      file.value.click();
    };
    const myup = async (e) => {
      var file = e.target.files[0];
      // console.log(files, 123);
      const param = new FormData(); // 创建form对象
      param.append("file", file); // 通过append向form对象添加数据
      param.append("chunk", "0"); // 添加form表单中其他数据
      console.log(file.name);
      var filename = file.name;
      var excelname = filename.substring(filename.lastIndexOf("."));
      console.log(excelname);
      if (excelname != ".xls" && excelname != ".xlsx") {
        alert("请先下载模板后再上传!");
      } else {
        const result = await uploadsecurity(param);
        if (result.code == 0) {
          ElMessage({
            type: "success",
            message: "上传成功",
          });
          refreshTable();
        }
        console.log("result", result);
      }
    };
    // 下载模板
    const download = async () => {
      window.open(window.xlsxUrl + "实有安防设施信息导入模板1.xlsx");
    };
    // 导出
    const exporting = async () => {
      const res = await derivesecurity(tableRef.value.form);
      console.log(res);
      const fileName = `${+new Date()}.xls`;
      const blob = new Blob([res], {
        type: "c",
      });
      if (navigator.msSaveBlob) {
        navigator.msSaveBlob(blob, fileName);
      } else {
        const link = document.createElement("a");
        link.href = URL.createObjectURL(blob);
        link.download = fileName;
        link.click();
        URL.revokeObjectURL(link.href);
      }
    };

    // 导出全部
    const exportingAll = async () => {
      const params = {
        allowpage: true,
      };
      const res = await derivesecurity(params);
      console.log(res);
      const fileName = `${+new Date()}.xls`;
      const blob = new Blob([res], {
        type: "application/vnd.ms-excel;charset=utf-8",
      });
      if (navigator.msSaveBlob) {
        navigator.msSaveBlob(blob, fileName);
      } else {
        const link = document.createElement("a");
        link.href = URL.createObjectURL(blob);
        link.download = fileName;
        link.click();
        URL.revokeObjectURL(link.href);
      }
    };
    return {
      ...refData,
      optionsq,
      clickTable,
      filterNode,
      currentChange,
      addButton,
      refreshTable,
      tableRef,
      formRef,
      resetForm,
      delUser,
      hzTableSelect,
      handleClick,
      securitylist,
      userSubmit,
      uploade,
      file,
      myup,
      download,
      exporting,
      exportingAll,
    };
  },
});
</script>
<style lang="scss" scoped>
.ActualSecurityFacilities {
  .tree-card {
    height: 100%;
    width: 300px;
    .input-with-select {
      margin-bottom: 10px;
    }
    .tree-box {
      flex: 1;
      overflow: auto;
      position: relative;
      .tree-header {
        position: sticky;
        top: 0;
        z-index: 2;
        padding: 10px 0;
        background-color: var(--el-color-white);
        color: var(--el-text-color-regular);
        @include flex-row-sb-c;
        .tree-name {
          flex: 1;
          margin-right: 10px;
          padding-left: 48px;
        }
        .tree-status {
          width: 50px;
        }
      }
    }
  }
  .tabs-card {
    flex: 1;
    margin-left: 10px;
    .el-row {
      margin: 8px 0;
      .security-count {
        @include flex-row-s-c;
        .el-button {
          border-radius: 16px;
        }
      }
    }
    .table-box {
      flex: 1;
      overflow: hidden;
      img {
        width: 42%;
        height: 90px;
      }
      .table-role {
        color: #294a7c;
        cursor: pointer;
        span {
          border-bottom: 1px solid;
        }
      }
    }
  }
}
</style>
